const GET_BLACKLIST = 'GET_BLACKLIST';
export const blackListActions = {
  GET_BLACKLIST,
};
